export default {"src":"/_next/static/media/ticket_disable.ea9585a9.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};